import { thousandSeperator } from "@utils/general/digit-separators";
import DataTable from "react-data-table-component";

const GoodIssueItemTable = (props: { data: any[] }) => {
  return (
    <DataTable
      //   conditionalRowStyles={[
      //     {
      //       when: (row) => row.product_code === "Totals:",
      //       style: {
      //         backgroundColor: "#f3f4f6",
      //         fontWeight: 500,
      //       },
      //     },
      //   ]}
      columns={[
        {
          name: "Product ID",
          selector: (row: any) => row.product_code,
        },
        {
          name: "Product Name",
          selector: (row: any) => row.product_name,
        },
        {
          name: "Request Qty",
          selector: (row: any) =>
            row.noAction ? null : thousandSeperator(row.request_qty || 0),
        },
        {
          name: "Unit",
          selector: (row: any) =>
            row.noAction ? null : thousandSeperator(row.unit_name || 0),
        },
      ]}
      data={props.data}
      striped
      responsive
      // pagination
      // paginationComponent={() => <ItemListPagination />}
    />
  );
};

export default GoodIssueItemTable;
